import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { EXPENSES_TYPES } from 'api/query-keys.ts';
import type { TExpenseTypeRes } from 'api/swagger';

export const useGetExpenseTypes = () => {
  return useQuery<TExpenseTypeRes[]>({
    queryKey: [EXPENSES_TYPES],
    queryFn: async () => {
      const { data } = await http.get<TExpenseTypeRes[]>(`/v1/expenses/types`);

      return data;
    },
    retry: 2,
    cacheTime: Infinity,
    staleTime: Infinity,
  });
};
